import { useCallback, useState } from "react";

export const useTemplateValidationError = () => {
  const [errors, setErrors] = useState<string[]>([]);

  const onValidationFail = useCallback((errors: any) => {
    setErrors(Object.keys(errors));
  }, []);

  return { errors, onValidationFail };
};
